import type { FallbackProps } from "react-error-boundary";

import { selectError } from "../app/appSlice";

import { useAppSelector } from "@/app/hooks";
import i18n from "@/app/i18n";
import { BugReportIcon } from "../app/components/icons";
import ErrorScreen from "../error_screen/ErrorScreen";

const SentryErrorPage = ({ error, resetErrorBoundary }: FallbackProps) => {
  const loadError = useAppSelector(selectError);

  return (
    !loadError && (
      <ErrorScreen
        Icon={BugReportIcon}
        title={i18n.t("error.generic.title")}
        description={i18n.t("error.generic.description")}
      />
    )
  );
};

export default SentryErrorPage;
